import "../../scss/NewChecklistLayout.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import SnackbarAlert from "../utils/SnackbarAlert";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import AreasModal from "./AreasModal";
import AreasCard from "./AreasCard";

const theme = createTheme({
  typography: {
    fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important`,
  },
});

function AreasLayout({ user }) {
  const [areas, setAreas] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [selectedPosition, setSelectedPosition] = useState(0);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("info");
  const [notificationMessage, setNotificationMessage] = useState("");
  const [refresher, setRefresher] = useState(0);

  useEffect(() => {
    const getAreas = async () => {
      await axios
        .get(`/api/areas`)
        .then((response) => {
          console.log(response.data.response);
          setAreas(response.data.response);
          setLoaded(true);
        })
        .catch((error) => {
          console.log(error);
          setLoaded(true);
          setOpen(true)
          setSeverity("error")
          setNotificationMessage("Error cargando areas")
        });
    };

    getAreas();
  }, [user, refresher]);

  const handleOpen = (action, position) => {
    setModalType(action);
    setSelectedPosition(position);
    setOpenModal(true);
  };
  const handleClose = () => setOpenModal(false);

  const updateRefresher = () => {
    setRefresher((prev) => prev + 1);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {openModal && (
          <AreasModal
            user={user}
            areas={areas}
            openModal={openModal}
            handleClose={handleClose}
            type={modalType}
            position={selectedPosition}
            updateRefresher={updateRefresher}
          />
        )}
        {loaded ? (
          <Box>
            <Paper
              sx={{
                p: 1.5,
                mb: 1,
                backgroundColor: "#E6D41E",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                component="h5"
                sx={{ color: "black", ml: 4 }}
              >
                Áreas
              </Typography>
            </Paper>
            <Container
              maxWidth="xl"
              sx={{ mt: 2, mb: 4, display: "flex", flexWrap: "wrap" }}
            >
              <Grid
                container
                spacing={{ xs: 2, md: 2 }}
                columns={{ xs: 3, sm: 6, md: 12 }}
              >
                {areas?.length > 0 ? (
                  areas.map((area, i) => (
                    <Grid key={i} item xs={12}>
                      <AreasCard
                        key={"p" + i}
                        areas={areas}
                        position={i}
                        handleOpen={handleOpen}
                      />
                    </Grid>
                  ))
                ) : (
                  <Grid item xs={12} sm={12} md={12}>
                    <Typography variant="h6" component="h4">
                      No tienes áreas agregadas, agrega una para poder agregar
                      items.
                    </Typography>
                  </Grid>
                )}
              </Grid>
              <Fab
                onClick={() => handleOpen("add")}
                aria-label="add"
                sx={{
                  position: "fixed",
                  bottom: 32,
                  right: 64,
                  background: "#E6D41E",
                }}
              >
                <AddIcon />
              </Fab>
            </Container>
          </Box>
        ) : (
          <Box>
            <Typography variant="body">Cargando...</Typography>
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={true}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        )}
        <SnackbarAlert
          open={open}
          setOpen={setOpen}
          severity={severity}
          notificationMessage={notificationMessage}
        />
      </Box>
    </ThemeProvider>
  );
}

export default AreasLayout;
